module.exports = __webpack_public_path__ + "media/images/service-icon-03-ff0da34f2d687204f666a950143c504c.png";